/** localStorage key for the customer session; the shipper app uses its own. */
export const SESSION_STORAGE_KEY = 'khaddi.client.token';

export const SHIPPER_APP_URL: string = import.meta.env.VITE_SHIPPER_APP_URL ?? 'https://shipper.khaoddi.com';

/**
 * There is no maps integration yet, so the customer types the distance and the
 * API prices delivery from it. 1.5 km is a typical order around the shop.
 */
export const DEFAULT_DISTANCE_KM = 1.5;
